export const cardImages = {
  'twoNow': 'HSBC_CC_2NOW_02242020.png',
  'one': 'HSBC_CC_ONE_PLUS_20251201.png',
  'gold': 'HSBC_CC_GOLD_20260710.png',
  'platinum': 'HSBC_CC_PLATINUM_20260710.png',
  'air': 'HSBC_CC_AIR_02242020.png',
  'pwe': 'HSBC_CC_PWE_02242020.png',
  'zero': 'HSBC_CC_ZERO_02242020.png',
  'viva': 'HSBC_CC_VIVA_20220816.png',
  'vivaPlus': 'HSBC_CC_VIVA_PLUS_20220816.png',
};

export const DEFAULT_CARD_IMAGE = cardImages.one;

const cardImagesByProductType = {
  '2now': cardImages.twoNow,
  one: cardImages.one,
  gold: cardImages.gold,
  platinum: cardImages.platinum,
  air: cardImages.air,
  pwe: cardImages.pwe,
  zero: cardImages.zero,
  viva: cardImages.viva,
  vivaPlus: cardImages.vivaPlus,
};

export const getCardImageByProductType = (productType) => cardImagesByProductType[productType] || DEFAULT_CARD_IMAGE;
